import useItemScreenStore, { EItemScreenMode } from '@modules/items/stores/useItemScreenStore';
import useClearGroundedQaScrollParams from '../hooks/useClearGroundedQaScrollParams.hook';
import useCanUseAiAssistantSidebar from '../hooks/useCanUseAiAssistantSidebar.hook';

import AiAssistantButton from './AiAssistantButton';

type TProps = {
  disabledTooltip?: string;
};

const AiAssistantSidebarButton = ({ disabledTooltip }: TProps) => {
  const { screenMode, setScreenMode } = useItemScreenStore();
  const clearGroundedQaScrollParams = useClearGroundedQaScrollParams();
  const canUseAiAssistantSidebar = useCanUseAiAssistantSidebar();
  const isOpen = screenMode === EItemScreenMode.AI;

  if (!canUseAiAssistantSidebar) return null;

  return (
    <AiAssistantButton
      appearance="primary"
      checked={isOpen}
      onClick={() => {
        if (isOpen) clearGroundedQaScrollParams();
        setScreenMode(isOpen ? undefined : EItemScreenMode.AI);
      }}
      disabledTooltip={disabledTooltip}
    />
  );
};

export default AiAssistantSidebarButton;
